import { render } from "./Skater.vue?vue&type=template&id=633d7723&ts=true"
import script from "./Skater.vue?vue&type=script&lang=ts"
export * from "./Skater.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/tomasfic/Projects/osobni/kometa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__